export default {
  personalInfo: {
    margin: '0',
  },
  summary: {
    margin: '0 0 0 24px',
  },
};
